// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Carousel_carouselCom__RW94U {
  height: 100%;
}
.Carousel_radiusBorder__ZvlTl {
  border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/Carousel/Carousel.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".carouselCom {\r\n  height: 100%;\r\n}\r\n.radiusBorder {\r\n  border-radius: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselCom": `Carousel_carouselCom__RW94U`,
	"radiusBorder": `Carousel_radiusBorder__ZvlTl`
};
export default ___CSS_LOADER_EXPORT___;
